module.exports = __webpack_public_path__ + "img/cirLight_0_0.b0502b82.png";